import React, { useState } from "react";
import SettingsNav from "../../../../parts/settings-nav";
import submit from "submit-form";
import { getRolesToShow, getRoleNameById } from "./utils/manage-coaches-utils";
import Dropdown from "../../../../parts/dropdown";
import SvgIcon from "../../../../parts/SvgIcon";
import { SettingsBackHandler } from "../../../coaching-portal/settings/components/SettingsBackHandler";

export const InviteNewCoachComponent = ({ locals, roleOrganizationName }) => {
  const {
    organizationPermissions = [],
    organizationRoles = [],
    activeUser,
    organizationOwner,
  } = locals;
  //roles to show in the dropdown
  const rolesToShow = getRolesToShow(organizationRoles, roleOrganizationName);
  //capture the coach role (initial state)
  const coachRoleId = organizationRoles?.find(
    ({ role }) => role === "Coach"
  )._id;
  //handle the selected role
  const [selectedRoleState, setSelectedRoleState] = useState(coachRoleId);
  //this state is because if the role is admin or owner, all the permissions should be enable
  const [selectedRoleNameState, setSelectedRoleNameState] = useState(
    getRoleNameById(organizationRoles, coachRoleId)
  );

  //state for the checkbox
  const [selectedPermissionsState, setSelectedPermissionsState] = useState([
    "",
  ]);
  const [emailValue, setEmailValue] = useState("");

  const userIsPush = Boolean(organizationOwner.pushAccountInfo);
  const userIsPress = Boolean(organizationOwner.pressAccountInfo);

  //filtering the permissions to show if the user is push or press
  const filteredPermissions = organizationPermissions.filter(
    ({ permission }) => {
      if (
        (permission !== "PUSH" && permission !== "PRESS") ||
        (permission === "PUSH" && userIsPush) ||
        (permission === "PRESS" && userIsPress)
      ) {
        return true;
      }
      return false;
    }
  );

  //to the select all permissions function
  const permissionIds = filteredPermissions.map((permission) => permission._id);

  /**
   * Go back
   */
  const handleGoBack = () => {
    submit(`/actions/refresh/`, {
      method: "GET",
      body: { organizationInviteCoach: "", roleOrganizationName: "" },
    });
  };

  /**
   * Capture the role selected
   * @param {*} roleId
   */
  const handleSetSelectedRole = (roleId) => {
    setSelectedRoleState(roleId);
    const roleName = getRoleNameById(organizationRoles, roleId);
    setSelectedRoleNameState(roleName);
    if (roleName === "Admin" || roleName === "Owner") {
      selectAll(true);
    }
  };

  /**
   * Handle the selected permissions
   * @param {*} id
   */
  const handleSelectionChange = (id) => {
    if (
      selectedRoleNameState !== "Admin" &&
      selectedRoleNameState !== "Owner"
    ) {
      //code for the check color
      let data = JSON.parse(JSON.stringify(selectedPermissionsState));
      if (!selectedPermissionsState.includes(id)) {
        data.length === 1 && data[0].length === 0
          ? (data = [id])
          : data.push(id);
      } else {
        if (selectedPermissionsState.length > 0) {
          const filetered = data.filter((val) => val != id);
          data = filetered.length > 0 ? filetered : [""];
        }
      }
      setSelectedPermissionsState(data);
    }
  };

  /**
   * Select all the permissions
   */
  const selectAll = (adminSelected = false) => {
    const reset =
      !adminSelected &&
      selectedRoleNameState !== "Admin" &&
      selectedRoleNameState !== "Owner";
    if (
      JSON.stringify(permissionIds) === JSON.stringify(selectedPermissionsState)
    ) {
      if (reset) {
        //unselect all
        setSelectedPermissionsState([""]);
      }
    } else {
      //select all
      setSelectedPermissionsState(permissionIds);
    }
  };

  /**
   * change email's value
   * @param {*} target
   */
  const handleInputChange = ({ target }) => {
    setEmailValue(target.value);
  };

  /**
   * Send an invitation to the coach
   * @param {*} e
   */
  const handleInvite = (e) => {
    if (validateForm()) {
      let newBody = null;
      const commonProperties = {
        organizationRoleName: selectedRoleNameState,
        organizationPermissions: selectedPermissionsState,
        organizationRoleId: false,
        organizationId: activeUser.organizationId,
        organizationRoleId: selectedRoleState,
        email: emailValue,
        organizationName:
          organizationOwner.businessName || organizationOwner.name,
      };

      newBody = {
        ...commonProperties,
        ...(organizationOwner.firebaseProjectId
          ? { firebaseProjectId: organizationOwner.firebaseProjectId }
          : {}),
        ...(organizationOwner.chatEnabled
          ? { chatEnabled: organizationOwner.chatEnabled }
          : {}),
        ...(organizationOwner.round != null
          ? { round: organizationOwner.round }
          : {}),
      };

      e.stopPropagation();
      e.preventDefault();
      submit(`/actions/organizations/invite-coach`, {
        method: "POST",
        body: newBody,
      });
    }
  };

  /**
   * Check if the email and permissions are not empty
   * @returns Boolean
   */
  const validateForm = () => {
    const isValidEmail = () => {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(emailValue).toLowerCase());
    };

    return selectedPermissionsState[0].length > 0 && isValidEmail();
  };

  return (
    <main className="settings">
      <SettingsNav classNames="mobile-hidden" />
      <section className="manage-coaches invite">
        <header>
          <h3 className="force-mobile-hidden">Manage Coaches</h3>
          <SettingsBackHandler
            customBackUrl={"/coaching-portal/settings/manage-coaches"}
            title={"Invite New Coach"}
          />

          <hgroup className="mobile-hidden">
            <button data-button-type="secondary" onClick={handleGoBack}>
              <SvgIcon src={"/img/new-icons/back-button.svg"} />
            </button>
            <p className="s1">Invite New Coach</p>
          </hgroup>
        </header>
        <div className="content">
          <div className="inputs-right">
            <div>
              <label> Email </label>
              <input
                value={emailValue}
                className="text-input"
                placeholder={`Enter email`}
                name="emailValue"
                id="emailValue"
                onChange={handleInputChange}
                sz="large"
              />
            </div>
            <div>
              <label>Role</label>
              <Dropdown
                summaryText={selectedRoleNameState}
                options={rolesToShow.map((role) => {
                  return { text: role.role, value: role._id };
                })}
                onSelectFn={handleSetSelectedRole}
              />
            </div>
          </div>
          <label>Permissions:</label>
          <section role="table-wrapper" data-borders-inside>
            <table role="report-table">
              <thead>
                <th>
                  <SvgIcon
                    onClick={() => {
                      selectAll();
                    }}
                    src={`/img/new-icons/${
                      JSON.stringify(permissionIds) ===
                      JSON.stringify(selectedPermissionsState)
                        ? "checked-square.svg"
                        : "unchecked-square.svg"
                    }`}
                    noFilterOnLight={
                      JSON.stringify(permissionIds) ===
                      JSON.stringify(selectedPermissionsState)
                        ? true
                        : false
                    }
                  />
                </th>
                <th>
                  <p className="s1">Permissions:</p>
                </th>
              </thead>
              <tbody>
                {filteredPermissions.map((item, idx) => {
                  const { _id, permission } = item;
                  const permissionFormat =
                    permission === "PUSH"
                      ? "PUSH (Subscriptions)"
                      : permission === "PRESS"
                      ? "PRESS (Gym Management)"
                      : permission;
                  return (
                    <tr key={_id}>
                      <td>
                        {selectedPermissionsState.includes(_id) ? (
                          <SvgIcon
                            src="/img/new-icons/checked-square.svg"
                            alt="checked"
                            style={{
                              cursor:
                                selectedRoleNameState === "Admin" ||
                                selectedRoleNameState === "Owner"
                                  ? "not-allowed"
                                  : "pointer",
                            }}
                            onClick={() => handleSelectionChange(_id)}
                            noFilterOnLight
                          />
                        ) : (
                          <SvgIcon
                            src="/img/new-icons/unchecked-square.svg"
                            alt="unchecked"
                            onClick={() => handleSelectionChange(_id)}
                          />
                        )}
                      </td>
                      <td>
                        <span className="permission-name-manage">
                          {permissionFormat}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </section>
          <button
            data-button-type="primary"
            disabled={validateForm() ? undefined : true}
            onClick={handleInvite}
          >
            Invite
          </button>
        </div>
      </section>
    </main>
  );
};
